/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import { Avatar } from '@mui/material';
import Cookies from 'js-cookie';
import { Container, Dropdown, Nav, Navbar, NavItem, NavLink, Tab } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import logo from '../../../assets/images/logo.svg';
import { NOTIFICATION_API_URL } from '../../../constants/ApiUrlConstants';
import { BASE_URL, IMAGE_URL, NOTIFICATION_API_CALL_TIME } from '../../../constants/Config';
import { DASHBOARD_ROUTE, PERSONAL_INFORMATION_ROUTE } from '../../../constants/RouteNameConstants';
import { resetDdashboardProofreader } from '../../../modules/authorization/Dashboard/actions';
import { resetProofreaderAllFiles } from '../../../modules/authorization/Files/AllFiles/actions';
import { capitalizeFirstLetter } from '../../../utils/CapitalizeFirstLetterUtils';
import { getUserInfo } from '../../../utils/UserInfoUtils';
import { UserLogout } from '../../../utils/UserLogout';
import { ReadNotificationRequest } from '../actions';

const createWorkerNotifications = () => {
  const workerCode = `
    self.onmessage = async function (event) {
      const { url, options } = event.data;
      try {
        const response = await fetch(url, options);
        const data = await response.json();
        
        if (response.status === 401) {
          self.postMessage({ type: "SESSION_EXPIRED" });
        } else {
          self.postMessage({ success: true, data });
        }
      } catch (error) {
        self.postMessage({ success: false, error: error.message });
      }
    };
  `;

  const blob = new Blob([workerCode], { type: 'application/javascript' });
  return new Worker(URL.createObjectURL(blob));
};

const Header = ({
  isSaveTranscriptInProgressRef,
  isTempSaveTranscript,
  setFullQcClick,
  setQcClick,
  setDueInDayClick,
  setDueInHalfDayClick,
  setLegalClick,
  handleFilterClear,
  setDashboardClick,
  setClaimFile,
  claimFile,
  allSpeakersRef,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const userInfo = getUserInfo();
  const dispatch = useDispatch();

  const [notificationData, setnotificationData] = useState(null);

  let readnNotificationDataAPI = useSelector((state) => state?.readnNotificationData?.user?.data?.value);

  let readnNotificationDataSet = readnNotificationDataAPI && JSON.parse(readnNotificationDataAPI);

  useEffect(() => {
    if (readnNotificationDataSet) {
      setnotificationData(readnNotificationDataSet);
    }
  }, [readnNotificationDataAPI]);

  const workerCode = (API_URL, param) => {
    const userData = Cookies.get('userDataProofreader');
    const token = userData ? JSON.parse(userData).Token : null;

    const headers = {
      ...(token && { Authorization: `Bearer ${token}` }),
      'Content-Type': 'application/json',
    };

    const worker = createWorkerNotifications();

    worker.postMessage({
      url: `${BASE_URL}${API_URL}?UserId=${param}`,
      options: {
        method: 'GET',
        headers: headers,
      },
    });

    worker.onmessage = (event) => {
      const { success, data, error, type } = event.data;

      if (type === 'SESSION_EXPIRED') {
        UserLogout();
      }

      if (success) {
        if (data?.success) {
          // setnotificationData(data?.value ? JSON.parse(data.value) : null);
        }
      }

      worker.terminate();
    };
  };

  useEffect(() => {
    if (!userInfo?.UserId) return; // Ensure userInfo is available before making the call

    const fetchNotifications = () => {
      workerCode(NOTIFICATION_API_URL, userInfo.UserId);
    };
    // Call the function immediately and set an interval to call it every 2 minutes
    fetchNotifications();
    const intervalId = setInterval(fetchNotifications, NOTIFICATION_API_CALL_TIME);

    // Cleanup: Clear the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, [dispatch]);

  // ReadNotificationRequest;
  const handleMarkAllAsRead = () => {
    let params = {
      userId: userInfo.UserId,
      notificationId: null,
      markAllAsRead: true,
    };
    dispatch(ReadNotificationRequest(params));
  };

  const handleReadNotofocation = (id) => {
    if (id) {
      let params = {
        userId: userInfo.UserId,
        notificationId: id,
        markAllAsRead: false,
      };
      dispatch(ReadNotificationRequest(params));
    }
  };

  let userProfileDetails = useSelector((state) => state?.userProfileDetails?.user?.data?.value);

  const [userFullName, setUserFullName] = useState(
    capitalizeFirstLetter(
      ((userInfo?.FirstName !== null && userInfo?.FileName !== 'null') === false ? '' : userInfo?.FirstName) +
        ' ' +
        ((userInfo?.LastName !== null && userInfo?.LastName !== 'null') === false ? '' : userInfo?.LastName),
    ),
  );
  const [userPhoto, setUserPhoto] = useState(
    userInfo?.ProfilePicture === ('' || null || undefined) ? '' : `${IMAGE_URL}/${userInfo?.ProfilePicture}`,
  );

  useEffect(() => {
    let profileData = userProfileDetails && JSON.parse(userProfileDetails);

    if (profileData?.ProfilePicture) {
      setUserPhoto(`${IMAGE_URL}/${profileData.ProfilePicture}`);
    } else if (userInfo?.ProfilePicture) {
      setUserPhoto(`${IMAGE_URL}/${userInfo.ProfilePicture}`);
    } else {
      setUserPhoto('');
    }

    if (profileData) {
      setUserFullName(capitalizeFirstLetter(profileData?.FirstName + ' ' + profileData?.LastName));
    } else {
      setUserFullName(
        capitalizeFirstLetter(
          ((userInfo?.FirstName !== null && userInfo?.FileName !== 'null') === false ? '' : userInfo?.FirstName) +
            ' ' +
            ((userInfo?.LastName !== null && userInfo?.LastName !== 'null') === false ? '' : userInfo?.LastName),
        ),
      );
    }
  }, [userInfo, location, userProfileDetails]);

  let notificationMarkAllAsRead = useSelector((state) => state?.readnNotificationData?.user?.data?.success);
  let notificationMarkAllAsReadLoading = useSelector((state) => state?.readnNotificationData?.loading);

  useEffect(() => {
    if (notificationMarkAllAsRead) {
      if (!notificationMarkAllAsReadLoading) {
        workerCode(NOTIFICATION_API_URL, userInfo.UserId);
      }
    }
  }, [notificationMarkAllAsRead]);

  return (
    <>
      <Navbar expand="lg" fixed="top" className="bg-body-white px-4 py-0">
        <Container fluid>
          <Navbar.Brand
            onClick={() => {
              if (isSaveTranscriptInProgressRef?.current === 1 || isTempSaveTranscript?.current === 1) {
                toast('Please wait, your transcript is being saved...', {
                  icon: '⚠️',
                  position: 'top-center',
                  style: {
                    background: '#f0ad4e',
                    color: '#fff',
                    width: '450px',
                  },
                });
              } else {
                if (claimFile) {
                  setClaimFile(false);
                  allSpeakersRef.current = null;
                }
                handleFilterClear();
                setFullQcClick(false);
                setQcClick(false);
                setDueInDayClick(false);
                setDueInHalfDayClick(false);
                setLegalClick(false);
                setDashboardClick(true);
                dispatch(resetDdashboardProofreader());
                dispatch(resetProofreaderAllFiles());
                navigate(DASHBOARD_ROUTE);
              }
            }}
            className="navbar-brand-space"
          >
            <img src={logo} className="img-fluid logo-img" alt="ANT logo" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav-main">
            {location?.pathname === DASHBOARD_ROUTE ? (
              <h3 className="nav-title-head"></h3>
            ) : (
              <h3 className="nav-title-head"></h3>
            )}
            <div className="d-flex align-items-center gap-4">
              {/* {notificationData && ( */}
              <Navbar.Text>
                <Dropdown as={NavItem} className="w-100 notification-head-dropdown" align="end">
                  <Dropdown.Toggle as={NavLink}>
                    <div
                      className={
                        !notificationData?.AllNotifications ||
                        !Array.isArray(notificationData.AllNotifications) ||
                        notificationData?.AllNotifications?.filter((notif) => !notif.IsRead).length === 0
                          ? 'noti-bell-icon'
                          : 'noti-icon-wrapper'
                      }
                    >
                      <NotificationsOutlinedIcon />
                    </div>
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="notification-dropdown">
                    <div className="notifications-header">
                      <div>
                        Notifications{' '}
                        <span className="badge badge-primary">
                          {notificationData?.AllNotifications?.filter((notif) => !notif.IsRead).length > 99
                            ? '99+'
                            : notificationData?.AllNotifications?.filter((notif) => !notif.IsRead).length}
                        </span>
                      </div>
                    </div>
                    <Tab.Container id="left-tabs-example" defaultActiveKey="first">
                      <div className="notifications-tab-view">
                        <Nav variant="pills">
                          <Nav.Item>
                            <Nav.Link eventKey="first">Inbox</Nav.Link>
                          </Nav.Item>
                          <Nav.Item>
                            <Nav.Link eventKey="second">Unread</Nav.Link>
                          </Nav.Item>
                        </Nav>
                        <button
                          className="mark-link"
                          disabled={notificationData?.AllNotifications?.filter((notif) => !notif.IsRead).length === 0}
                          onClick={handleMarkAllAsRead}
                        >
                          Mark all as read
                        </button>
                      </div>
                      <Tab.Content>
                        <Tab.Pane eventKey="first">
                          <ul className="notifications-scroll">
                            {!notificationData?.AllNotifications?.length ? (
                              <li className="notifications-dropdown-list my-4 text-center fnt-14">No Data Found</li>
                            ) : (
                              notificationData.AllNotifications?.map((data, index) => (
                                <li
                                  className={`notifications-dropdown-list ${data?.IsRead ? 'read' : 'unread'}`}
                                  key={index}
                                  onClick={() => {
                                    if (!data?.IsRead) {
                                      handleReadNotofocation(data?.Id);
                                    }
                                  }}
                                >
                                  <div className="notifications-dropdown-item">
                                    <div className="position-relative user-info-icon">
                                      {!data?.IsRead && <span className="new-notifications-badge"></span>}
                                      {data?.ProfilePicture ? (
                                        <Avatar
                                          alt={data?.NotifiedByName}
                                          src={`${IMAGE_URL}/${data.ProfilePicture}`}
                                          className="img-fluid"
                                        />
                                      ) : (
                                        <Avatar className="img-fluid">{data?.NotifiedByName?.charAt(0)}</Avatar>
                                      )}
                                    </div>

                                    {/* ==== Notification content based on type ==== */}
                                    {data?.NotificationType === 11 && (
                                      <div className="notifications-content">
                                        <div>
                                          You've exceeded the time limit for{' '}
                                          <span className="fw-bold">{data?.FileName}</span>. Please resume work to
                                          finish on time.
                                        </div>
                                        <div className="py-2">{data?.RelativeCreatedDate}</div>
                                        {data?.FileId && (
                                          <button
                                            onClick={() => {
                                              if (claimFile) {
                                                setClaimFile(false);
                                                allSpeakersRef.current = null;
                                              }
                                              navigate(
                                                `/${window.endPoint.IS_SLATE ? 'edit-copy' : 'editor'}/${data?.FileId}`,
                                              );
                                              if (location?.pathname?.includes('/editor')) {
                                                navigate(0);
                                              }
                                            }}
                                            className="btn btn-primary fnt-14 px-2 py-1"
                                          >
                                            Resume
                                          </button>
                                        )}
                                      </div>
                                    )}

                                    {data?.NotificationType === 12 && (
                                      <div className="notifications-content">
                                        <div>
                                          Rework on <span className="fw-bold">{data?.FileName}</span> completed.
                                        </div>
                                        <div className="py-2">{data?.RelativeCreatedDate}</div>
                                        {data?.FileId && (
                                          <button
                                            onClick={() => {
                                              if (claimFile) {
                                                setClaimFile(false);
                                                allSpeakersRef.current = null;
                                              }
                                              navigate(
                                                `/${window.endPoint.IS_SLATE ? 'editor-copy' : 'editor'}/${data?.FileId}`,
                                              );
                                              if (location?.pathname?.includes('/editor')) {
                                                navigate(0);
                                              }
                                            }}
                                            className="btn btn-primary fnt-14 px-2 py-1"
                                          >
                                            Open
                                          </button>
                                        )}
                                      </div>
                                    )}

                                    {data?.NotificationType === 13 && (
                                      <div className="notifications-content">
                                        <div>
                                          You have sent <span className="fw-bold">{data?.NotifiedByName}</span> for
                                          rework to <span className="fw-bold">{data?.FileName}</span> with following
                                          feedback <span className="fw-bold">{data?.Feedback}</span>.
                                        </div>
                                        <div className="py-2">{data?.RelativeCreatedDate}</div>
                                      </div>
                                    )}

                                    {data?.NotificationType === 14 && (
                                      <div className="notifications-content">
                                        <div>
                                          Admin has forced unclaim on file{' '}
                                          <span className="fw-bold">{data?.FileName}</span>, previously in your bin.
                                        </div>
                                        <div className="py-2">{data?.RelativeCreatedDate}</div>
                                      </div>
                                    )}
                                  </div>
                                </li>
                              ))
                            )}
                          </ul>
                        </Tab.Pane>
                        <Tab.Pane eventKey="second">
                          <ul className="notifications-scroll">
                            {!notificationData?.AllNotifications ||
                            notificationData?.AllNotifications?.filter((notif) => !notif.IsRead).length === 0 ? (
                              <li className="notifications-dropdown-list my-4 text-center fnt-14">No Data Found</li>
                            ) : (
                              notificationData.AllNotifications?.filter((notif) => !notif.IsRead).map((data, index) => (
                                <li
                                  className={`notifications-dropdown-list ${data?.IsRead ? 'read' : 'unread'}`}
                                  key={index}
                                  onClick={() => handleReadNotofocation(data?.Id)}
                                >
                                  <div className="notifications-dropdown-item">
                                    <div className="position-relative user-info-icon">
                                      <span className="new-notifications-badge"></span>
                                      {data?.ProfilePicture ? (
                                        <Avatar
                                          alt={data?.NotifiedByName}
                                          src={`${IMAGE_URL}/${data.ProfilePicture}`}
                                          className="img-fluid"
                                        />
                                      ) : (
                                        <Avatar className="img-fluid">{data?.NotifiedByName?.charAt(0)}</Avatar>
                                      )}
                                    </div>

                                    {/* ==== Notification Content Based on Type ==== */}
                                    {data?.NotificationType === 11 && (
                                      <div className="notifications-content">
                                        <div>
                                          You've exceeded the time limit for{' '}
                                          <span className="fw-bold">{data?.FileName}</span>. Please resume work to
                                          finish on time.
                                        </div>
                                        <div className="py-2">{data?.RelativeCreatedDate}</div>
                                        {data?.FileId && (
                                          <button
                                            onClick={() => {
                                              if (claimFile) {
                                                setClaimFile(false);
                                                allSpeakersRef.current = null;
                                              }
                                              navigate(
                                                `/${window.endPoint.IS_SLATE ? 'editor-copy' : 'editor'}/${data?.FileId}`,
                                              );
                                              if (location?.pathname?.includes('/editor')) {
                                                navigate(0);
                                              }
                                            }}
                                            className="btn btn-primary fnt-14 px-2 py-1"
                                          >
                                            Resume
                                          </button>
                                        )}
                                      </div>
                                    )}

                                    {data?.NotificationType === 12 && (
                                      <div className="notifications-content">
                                        <div>
                                          Rework on <span className="fw-bold">{data?.FileName}</span> completed.
                                        </div>
                                        <div className="py-2">{data?.RelativeCreatedDate}</div>
                                        {data?.FileId && (
                                          <button
                                            onClick={() => {
                                              if (claimFile) {
                                                setClaimFile(false);
                                                allSpeakersRef.current = null;
                                              }
                                              navigate(
                                                `/${window.endPoint.IS_SLATE ? 'editor-copy' : 'editor'}/${data?.FileId}`,
                                              );
                                              if (location?.pathname?.includes('/editor')) {
                                                navigate(0);
                                              }
                                            }}
                                            className="btn btn-primary fnt-14 px-2 py-1"
                                          >
                                            Open
                                          </button>
                                        )}
                                      </div>
                                    )}

                                    {data?.NotificationType === 13 && (
                                      <div className="notifications-content">
                                        <div>
                                          You have sent <span className="fw-bold">{data?.NotifiedByName}</span> for
                                          rework to <span className="fw-bold">{data?.FileName}</span> with following
                                          feedback <span className="fw-bold">{data?.Feedback}</span>.
                                        </div>
                                        <div className="py-2">{data?.RelativeCreatedDate}</div>
                                      </div>
                                    )}

                                    {data?.NotificationType === 14 && (
                                      <div className="notifications-content">
                                        <div>
                                          Admin has forced unclaim on file{' '}
                                          <span className="fw-bold">{data?.FileName}</span>, previously in your bin.
                                        </div>
                                        <div className="py-2">{data?.RelativeCreatedDate}</div>
                                      </div>
                                    )}
                                  </div>
                                </li>
                              ))
                            )}
                          </ul>
                        </Tab.Pane>
                      </Tab.Content>
                    </Tab.Container>
                  </Dropdown.Menu>
                </Dropdown>
              </Navbar.Text>
              {/* )} */}
              <Dropdown as={NavItem} className="w-100">
                <Dropdown.Toggle as={NavLink} className="nav-user">
                  {userPhoto !== null || userPhoto !== undefined || userPhoto !== '' ? (
                    <Avatar alt={userFullName} src={userPhoto} className="navbar-profile-avatar me-3" />
                  ) : (
                    <Avatar className="navbar-profile-avatar me-3">
                      {userFullName
                        .replace(/\b(null|undefined|false)\b/gi, '')
                        .replace(/\s+/g, ' ')
                        .trim()
                        .charAt(0)}
                    </Avatar>
                  )}
                  <div className="d-lg-flex flex-column d-none me-2 fnt-14">
                    {userFullName
                      .replace(/\b(null|undefined|false)\b/gi, '')
                      .replace(/\s+/g, ' ')
                      .trim()}
                    <span className="my-0 fw-normal fnt-12">Proofreader</span>
                  </div>
                  <ExpandMoreRoundedIcon />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => navigate(PERSONAL_INFORMATION_ROUTE)}>My Account</Dropdown.Item>
                  <Dropdown.Item onClick={UserLogout}>Logout</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default Header;
